export const pointer = '{0}';

export default (template, eventId) => template.replace(pointer, eventId);